<script setup lang="ts">
import type { ContentConversation } from '~/models/Content/ContentConversation'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { ContentType } from '~/models/Content/ContentType'
import useContentApi from '~/api/contentApi'
import ConversationList from '~/components/conversation/ConversationList.vue'

const { locationId } = defineProps<{ locationId: number }>()

const { findContents } = useContentApi()

const { data } = useQuery({
  enabled: locationId > 0,
  queryKey: computed(() => ['conversation-list', locationId]),
  queryFn: () => findContents<ContentConversation>({
    locationIdCriterion: [locationId],
    contentTypeCriterion: [ContentType.Conversation],
  }, 1).then(([data]) => data),
  staleTime: Infinity,
  retry: 1,
})
</script>

<template>
  <ConversationList
    v-if="data"
    :item="data"
  />
</template>
